import type { RunsIn } from '../../../env';
import { env } from '../../../env';
import type { AccessTokenInfo } from '../../../helpers/token/getAccessTokenInfo';

const userIdentifierByRunsIn: Record<
	RunsIn,
	(tokenInfo: AccessTokenInfo) => string | undefined
> = {
	BANK: (tokenInfo) => tokenInfo.pidUuid,
	FIP: (tokenInfo) => tokenInfo.userId,
};

export const getUserIdentifierFromTokenInfo = (
	tokenInfo: AccessTokenInfo,
): string | undefined => userIdentifierByRunsIn[env.CLIENT_RUNS_IN](tokenInfo);
